import React, {FC} from "react"
import styled, {css} from "styled-components"

export interface Props {
  selected?: boolean
  onSelect: () => void
  full?: boolean
}

type CSSProps = Prettify<Pick<Props, "variant" | "selected" | "full">>

const Container = styled.div<CSSProps>`
  ${({selected, full, theme}) => css`
    position: relative;
    user-select: none;
    display: flex;
    flex: ${full ? "1" : "0"};
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${theme.spacing.two};
    border: 1px solid ${theme.colors.primary2};
    border-radius: ${theme.spacing.one};
    background-color: ${theme.colors.greys.lightest};
    padding: ${theme.spacing.two} ${theme.spacing.three} ${theme.spacing.two} ${theme.spacing.two};
    &:hover {
      cursor: pointer;
      border-color: ${selected ? theme.colors.primary2 : theme.colors.primary1};
    }
  `}
`

const RadioItem = styled.div<CSSProps>`
  ${({selected, theme}) => css`
    width: 12px;
    height: 12px;
    background-color: ${selected ? theme.colors.primary2 : theme.colors.utility.subdued};
    border-radius: 50%;
  `}
`

const RadioContainer = styled.div<CSSProps>`
  ${({selected, theme}) => css`
    position: absolute;
    top: ${theme.spacing.one};
    right: ${theme.spacing.one};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: 1px solid ${selected ? theme.colors.primary2 : theme.colors.utility.subdued};
    border-radius: 50%;
    ${Container}:hover & {
      border-color: ${selected ? theme.colors.primary2 : theme.colors.primary1};
    }
  `}
`

const CardOption: FC<Props> = ({selected, onSelect, full, children}) => {
  return (
    <Container selected={selected} onClick={onSelect} full={full}>
      <RadioContainer selected={selected}>{selected && <RadioItem selected={selected} />}</RadioContainer>
      {children}
    </Container>
  )
}

export default CardOption
